module.exports = __webpack_public_path__ + "img/icon_android.2d5b8ab5.svg";